import { Injectable } from '@angular/core';
import { from, Observable, ReplaySubject } from 'rxjs';

declare global {
  interface Window {
    altcha: any;           
  }
}

@Injectable({ providedIn: 'root' })
export class AltchaService {
  private ready$ = new ReplaySubject<void>(1);
  private scriptId = 'altcha-script';

  /** load altcha.io script once and emit ready */
  load(): Observable<void> {
    if (document.getElementById(this.scriptId)) {
      this.ready$.next();        // already loaded
      return this.ready$.asObservable();
    }

    const script = document.createElement('script');
    script.id = this.scriptId;
    script.src = 'https://cdn.jsdelivr.net/gh/altcha-org/altcha@main/dist/altcha.min.js';   // official CDN mirror
    script.async = true;
    script.onload = () => this.ready$.next();
    document.head.appendChild(script);

    return this.ready$.asObservable();
  }

  /** render a widget into #element and resolve verification token */
  async challenge(element: HTMLElement, siteKey: string): Promise<string> {
    await this.load().toPromise();

    return new Promise<string>((resolve, reject) => {
      const widget = window.altcha(element, {
        sitekey: siteKey,
        theme: 'light',
        callback: (token: string) => resolve(token),
        'error-callback': () =>
          reject(new Error('Altcha verification failed, please retry')),
      });

      // Expose a way to reset if the user resubmits the form
      (widget as any).resetAltcha = () => window.altcha.reset(widget);
    });
  }
}